module.exports = __webpack_public_path__ + "img/Imagen1.cb035802.webp";